import { c as _c } from "react/compiler-runtime";
import { LocalAlert } from "@navikt/ds-react";
import { UiSelector } from "@/utils/uiSelectors";
export default function ThankYouAlert() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LocalAlert status="success" data-testid={UiSelector.ThankYouAlert}><LocalAlert.Header><LocalAlert.Title>Nærmeste leder er registrert</LocalAlert.Title></LocalAlert.Header><LocalAlert.Content>Takk, du har sendt inn svarene dine til Nav.</LocalAlert.Content></LocalAlert>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}